<div class="space-y-2">
  <div class="border border-gray-400 overflow-hidden" style="height: 210px; width: 100%;">
    <video autoplay loop muted playsinline width="100%" height="auto" class="object-contain">
      <source src="/videos/scale.mp4" type="video/mp4" />
    </video>
  </div>
  <div>
    Find the sheet scale (if it exists). Select the page(s) you want to update, then click "Set Page Scales"
    to define it for those pages.
  </div>
</div>
